import jwt_decode from 'jwt-decode'
import { NavigateFunction } from 'react-router-dom'
import { doLogoutApi, getLoginTokenApi } from '../../apiCalls'
import appConfig from '../../config'
import { decodeRole } from '../../decoders/role'
import { isHttpError } from '../../libs/fetchJson'
import {
	deleteEclipsMetadata,
	delIntersessionInfo,
	getEclipsMetadata,
	setIntersessionAppLoginData,
} from '../../libs/intersession'
import { HttpError, LoginResponse, LoginToken } from '../../model/model'
import { AppThunkPromise, TeloDispatch } from '../../store'
import azureCommunicationActions from '../azureCommunication/actions'
import errorsActions from '../errors/actions'
import { deleteIntersessionRoomDevice } from './../../libs/intersession'
import { slice } from './slice'

const convertErrorToText = (error: unknown): string => {
	if (typeof error === 'string') {
		return error
	}

	if (error instanceof Error) {
		return error.message
	}

	return 'Unknown error'
}

const getLoginTokenAction =
	(
		code: string,
		redirectUri: string,
		navigate: NavigateFunction,
		eclipsUsername?: string,
	) =>
	(dispatch: TeloDispatch) => {
		dispatch(slice.actions.setAppLoginStatus('logging in'))
		getLoginTokenApi(code, redirectUri, eclipsUsername)
			.then((decodedRes: LoginResponse | HttpError) => {
				if (isHttpError(decodedRes)) {
					if (eclipsUsername !== undefined) {
						navigate('/logout')
						return
					}
					return dispatch(errorsActions.setHttpError(decodedRes))
				}

				dispatch(errorsActions.resetLoginError())
				const token = decodedRes.token
				const decodedToken = jwt_decode(token) as LoginToken
				const expirationDate = new Date(decodedToken.exp * 1000).toString()
				const role = decodeRole(decodedToken.role)
				const appLoginData = {
					token,
					expirationDate,
					role,
					eclipsUserVerified: eclipsUsername !== undefined ? true : false,
				}
				dispatch(slice.actions.setAppLoginData(appLoginData))
				setIntersessionAppLoginData(appLoginData)
			})
			.catch((error: unknown) => {
				dispatch(
					errorsActions.setLoginError({
						message: 'unauthorized',
						details: convertErrorToText(error),
					}),
				)
			})
	}

const logoutAction =
	(preserveEclipsData: boolean = false): AppThunkPromise =>
	(dispatch: TeloDispatch) => {
		const eclipsMetadata = getEclipsMetadata()
		const isAppInsideEclips = !!eclipsMetadata

		const logoutPromise =
			isAppInsideEclips !== true ? doLogoutApi() : Promise.resolve()

		return logoutPromise
			.catch(() => {
				// if token is expired the logout will fail with 401, just ignore it
			})
			.finally(() => {
				if (preserveEclipsData === false) {
					deleteEclipsMetadata()
				}
				delIntersessionInfo()
				deleteIntersessionRoomDevice()
				dispatch(azureCommunicationActions.resetAzureCommunication())
				dispatch(slice.actions.delAppLoginData())
				if (isAppInsideEclips !== true) {
					window.location.href = appConfig.logout
				}
			})
	}

const authActions = {
	...slice.actions,
	getLoginTokenAction,
	logoutAction,
}

export default authActions
